import React, { useState, useEffect } from "react";
import { ApiPromise, WsProvider } from "@polkadot/api";
import { formatDistanceToNow } from "date-fns";
import notification from "../assets/notification.mp3";

const Events = () => {
  const [events, setEvents] = useState([]);
  const [recentEventId, setRecentEventId] = useState(null);
  const [index, setIndex] = useState(0);

  const wsEndpoints = [
    "wss://weave-aws.testnet.dhiway.net", // Network 1
    "wss://weave1.testnet.cord.network", // Network 2 (Replace with actual network)
  ];

  let apiInstances = {}; // Global store for API instances

  const messages = [
    "Looking at the events on the chain...",
    "Waiting for new events...",
    "Listening for chain updates...",
    "Tracking live chain activity...",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 1000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

useEffect(() => {
  let unsubscribes = [];

  const fetchEventsFromNetwork = async (wsEndpoint) => {
    if (apiInstances[wsEndpoint]) return; // Prevent duplicate connections

    const provider = new WsProvider(wsEndpoint);
    const api = await ApiPromise.create({ provider });
    apiInstances[wsEndpoint] = api;

    console.log(`Connected to ${wsEndpoint}`);

    const unsubscribe = await api.query.system.events(
      async (receivedEvents) => {
        // Get latest block hash & header
        const blockHash = await api.rpc.chain.getFinalizedHead();
        const header = await api.rpc.chain.getHeader(blockHash);
        const blockNumber = header.number.toNumber();

        setEvents((prevEvents) => {
          let newEventsAdded = false;
          let newEventId = null;

          const newEvents = receivedEvents
            .map(({ event, phase }) => {
              const { section, method, data } = event;
              if (method === "RegistryEntryCreated" && section === "entry") {
                const statementId = data.registryEntryId.toHuman();

                // ✅ Unique ID includes block + network + statementId
                const uniqueId = `${statementId}-${blockNumber}-${wsEndpoint}`;
                
                // ✅ Skip if already present
                if (prevEvents.some((e) => e.id === uniqueId)) {
                  return null;
                }

                newEventsAdded = true;
                newEventId = statementId;

                return {
                  id: uniqueId,
                  network: wsEndpoint,
                  hash: phase.toString().slice(0, 10),
                  method: "Entry Registered",
                  blockNumber,
                  statementId,
                  issuer: data.creatorProfileId.toHuman(),
                  timestamp: Date.now(),
                };
              }

              if (method === "Create" && section === "registries") {
                const registryId = data[0].toHuman();
                const creator = data[1].toHuman();
                const authorization = data[2].toHuman();

                console.log("Registry Created:", {
                  registryId,
                  creator,
                  authorization,
                  blockNumber,
                  network: wsEndpoint,
                });
              }

              return null;
            })
            .filter((event) => event !== null);

          if (newEventsAdded) {
            const sound = new Audio(notification);
            sound.play().catch((err) => console.log("Sound play error:", err));

            const element = document.getElementById("scroll-content");
            if (element) {
              element.scrollTo({ top: 0, behavior: "smooth" });
            }

            setRecentEventId(newEventId);
            setTimeout(() => setRecentEventId(null), 6000);
          }

          return [...newEvents, ...prevEvents].slice(0, 10);
        });
      }
    );

    unsubscribes.push(unsubscribe);
  };

  wsEndpoints.forEach(fetchEventsFromNetwork);

  return () => {
    unsubscribes.forEach((unsub) => unsub && unsub());
  };
}, []);


  function truncateText(text, start = 13, end = 12) {
    if (text.length > start + end) {
      return text.slice(0, start) + "..." + text.slice(-end);
    }
    return text;
  }

  return (
    <>
      <div className="event-holder">
        <div className="">
          {/* <h6 className="text-center mt-3">Chains</h6> */}
          {/* <div className="d-flex justify-content-center align-items-center pb-1  mb-0">
            <div className="blinking-dot"></div>

            <span className="ml-10-status font-text-bold hover:text-blue-500 cursor-pointer">
              <a
                href="https://apps.cord.network/?rpc=wss://weave1.testnet.cord.network/#/explorer"
                target="_blank"
                rel="noopener noreferrer"
                className="no-underline text-decoration-none color-linkheader"
              >
                weavenet.cord.network
                <i className="fa-solid fa-up-right-from-square ml-2"></i>
              </a>
            </span>
          </div> */}
          {/* <div className="d-flex justify-content-center align-items-center pb-1  mb-0">
            <div className="blinking-dot"></div>

            <span className="ml-10-status font-text-bold hover:text-blue-500 cursor-pointer">
              <a
                href="https://apps.cord.network/?rpc=wss%3A%2F%2Fregistries.demo.cord.network%2F#/explorer"
                target="_blank"
                rel="noopener noreferrer"
                className="no-underline text-decoration-none color-linkheader"
              >
                registeries.cord.network
                <i className="fa-solid fa-up-right-from-square ml-2"></i>
              </a>
            </span>
          </div> */}
        </div>
        <ul className="p-1 scrool-event-content" id="scroll-content">
          {events.map((event, index) => (
            <li
              key={index}
              className={`flex justify-between items-center border-b p-2 event-content ${
                event.id === recentEventId ? "active" : ""
              }`}
            >
              <div className="text-gray-500">
                {/* <span className="font-mono">{event.hash}...</span> */}
              </div>
              <div className="text-sm">
                <p className="mb-1 header-text">
                  <strong>{event.method}</strong>
                </p>
                 <p className="text-head mb-1">
                  <strong className="text-md">Block Number:</strong> 
                   <a href={`https://apps.cord.network/?rpc=wss://weave-aws.testnet.dhiway.net#/explorer/query/${event.blockNumber}`} target="_blank" rel="noopener noreferrer" >
                                <span className="text-blue-500 hover:underline text-md">
                                    {event.blockNumber}
                                </span>
                            </a>
                </p>
                {event.schemaId && (
                  <p className="mb-1 text-head">
                    <strong className="text-md">Schema ID:</strong> {truncateText(event.schemaId)}
                  </p>
                )}
                {event.creator && (
                  <p className="mb-1 text-head">
                    <strong className="text-md">Creator:</strong> {event.creator}
                  </p>
                )}
                {event.statementId && (
                  <p className="text-head mb-1">
                    <strong className="text-md">Entry ID:</strong>{" "}
                    {truncateText(event.statementId)}
                  </p>
                )}
                {event.hashValue && (
                  <p className="text-head mb-1">
                    <strong className="text-md">Hash:</strong> {truncateText(event.hashValue)}
                  </p>
                )}
                {event.issuer && (
                  <p className="text-head mb-1">
                    <strong className="text-md">Issuer:</strong> {truncateText(event.issuer)}
                  </p>
                )}
                {event.blockHeight && (
                  <p className="text-head mb-1">
                    <strong className="text-md">Block No:</strong>{" "}
                    <a
                      href={`https://apps.cord.network/?rpc=wss%3A%2F%weave3.testnet.dhiway.net%2F#/explorer/query/${event.blockHeight.replace(/,|\s/g, "")}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 hover:underline"
                    >
                      {event.blockHeight.replace(/,|\s/g, "")}
                    </a>
                  </p>
                )}
                <p className="text-sm text-head text-grey mb-1">
                  {formatDistanceToNow(event.timestamp, { addSuffix: true })}
                </p>
              </div>
            </li>
          ))}
          <div className="message-container loader-event">
            <div className="blockspinn">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <p key={index} className="fade-content font-sm">
              {messages[index]}
            </p>
          </div>
        </ul>
      </div>
    </>
  );
};

export default Events;
